import { useEffect } from 'react';
import { useIsFocused } from './focused';
import { SPECIAL_ACTIONS } from '@spa/shared/constants/navigationKeys';

const FOCUSED_ITEM = '[tabindex="-1"]:focus';
const SELECTABLE_ELEMENTS = 'input, [tabindex="-1"]';

export const getItems = container => (container ? [...container.querySelectorAll(SELECTABLE_ELEMENTS)] : []);

export const useKeyHandler = (ref, [state, dispatch]) => {
  const { isFocused, blur, focus } = useIsFocused(ref);

  const buildKeyDownHandler = container => e => {
    if (!isFocused) {
      return;
    }

    const items = getItems(container);
    const item =
      container.contains(document.activeElement) || document.activeElement === container
        ? document.activeElement
        : container.querySelector(FOCUSED_ITEM);

    dispatch({ type: e.keyCode, items, item });
  };

  useEffect(() => {
    const items = getItems(ref.current);

    if (items.length < 1) {
      dispatch({ type: SPECIAL_ACTIONS.RESTORE });

      return;
    }

    const keyDownHandler = buildKeyDownHandler(ref.current);
    document.addEventListener('keydown', keyDownHandler);

    return () => document.removeEventListener('keydown', keyDownHandler);
  });

  return { isFocused, blur, focus, state, dispatch };
};
